// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import getColor from "@insite/mobius/utilities/getColor";
import { color, MediaQuery } from "@rugby/XDL/Utilities";
import { xFlexGap } from "@rugby/XDL/Utilities/SharedStyles";
import { css } from "styled-components";

const specificCellWidth = 192;
export const invoicePaymentStyle = {
    notifyMessage: {
        wrapper: {
            css: css`
                display: flex;
                justify-content: flex-start;
                margin: 30px 0;
            `,
        },
    },
    header: {
        css: css`
            height: 60px;
        `,
    },
    loading: {
        wrapper: {
            css: css`
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 30px 0;
                min-height: 300px;
                align-items: center;
            `,
        },
    },
    balanceDueCell: {
        css: css`
            width: ${specificCellWidth}px;
            .wrapHead {
                max-width: 100px;
                width: 100px;
                white-space: break-spaces;
                display: block;
                padding-top: 22px;
                button {
                    display: inline-flex;
                }
            }
        `,
    },
    balanceDueWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    columnCell: {
        css: css`
            white-space: nowrap;
        `,
    },
    emptyCell: {
        css: css`
            background: white;
            border: 0;
            padding: 0;
            min-width: 20px;
            max-width: 20px;
            width: 20px;
        `,
    },
    shipToCell: {
        wrapper: {
            css: css`
                width: 160px;
                max-width: 160px;
                min-width: 160px;
                white-space: break-spaces;
            `,
        },
        text: {
            css: css`
                white-space: break-spaces;
            `,
        },
    },
    paymentAmountCell: {
        css: css`
            width: ${specificCellWidth}px;
            max-width: ${specificCellWidth}px;
            min-width: ${specificCellWidth}px;
            white-space: normal;
            text-align: center;

            input {
                margin-bottom: 15px;
            }
        `,
    },
    tableWrapper: {
        css: css`
            margin-bottom: 30px;
        `,
    },
    tableWrapperWithFilter: {
        css: css`
            margin-bottom: 30px;
            & > div {
                min-height: 300px;
            }
            ${xScreen.lte("sm")} {
                table th,
                table td {
                    min-width: 200px;
                    &:first-child {
                        position: static;
                    }
                }
            }
        `,
    },
    totalWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
            ${xFlexGap(60)}
            margin-bottom: 60px;
        `,
    },
    textFieldStyle: {
        cssOverrides: {
            descriptionWrapper: css`
                white-space: break-spaces;
            `,
        },
    },
    makePaymentBtn: {
        css: css`
            width: 100%;
            margin-top: 16px;
        `,
    },
    creditCardWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            max-width: 50%;
            .token-fields {
                overflow: visible;
            }
            .tokenEx_securityCodeWrapper {
                width: 100%;
            }
            ${MediaQuery.lte(680)} {
                max-width: 100%;
            }
        `,
    },
    applyLateFeeMessage: {
        css: css`
            margin-bottom: 16px;
            color: ${color("danger")};
            font-size: 20px;
        `,
    },
    ccAndPaymentWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            ${MediaQuery.lte(680)} {
                flex-direction: column;
            }
        `,
    },
    addRemark: {
        cssOverrides: {
            inputSelect: css`
                resize: none;
            `,
        },
    },
    addRemarkActions: {
        css: css`
            justify-content: flex-end;
        `,
    },
    incompletePaymentNote: {
        css: css`
            max-width: none;
        `,
    },
    tableHeaderWrapper: {
        css: css`
            display: flex;
            align-items: center;
            line-height: 14px;
            position: relative;
            height: 60px;
        `,
    },
    capitalizedTableHeaderWrapper: {
        css: css`
            display: flex;
            align-items: center;
            line-height: 14px;
            position: relative;
            text-transform: capitalize;
            height: 60px;
        `,
    },
    filters: {
        filterButton: {
            css: css`
                &:focus {
                    outline: none;
                }
            `,
        },
        filterIcon: {
            size: 14,
            color: "text.main",
            css: css`
                margin-left: 8px;
                &:focus {
                    outline: none;
                }
            `,
        },
        wrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                gap: 10px;
                position: absolute;
                top: 60px;
                background: ${color("common.white")};
                border-radius: 0 0 4px 4px;
                box-shadow: 0 0 15px 0 ${color("secondary", 0.25)};
            `,
        },
        searchWrapper: {
            css: css`
                padding: 30px 10px 0;
            `,
        },
        searchField: {
            css: css`
                margin-bottom: 5px;
                margin-top: 10px;
            `,
        },
        checkboxGroup: {
            css: css`
                display: flex;
                flex-direction: column;
                gap: 15px;
                max-height: 200px;
                overflow-y: auto;
                padding-left: 10px;
                min-height: 30px;
            `,
        },
        xIconWrapper: {
            css: css`
                position: absolute;
                right: 0;
                top: 0;
                padding: 5px;
                &:focus {
                    outline: none;
                }
            `,
        },
        xIcon: {
            size: 18,
            color: "text.main",
        },
        clearAll: {
            css: css`
                margin-bottom: 20px;
                ${xScreen.lte("sm")} {
                    margin-top: 20px;
                }
            `,
        },
        checkbox: {
            typographyProps: {
                size: 12,
                weight: "normal",
            },
            css: css`
                > span[role="checkbox"] {
                    width: 16px;
                    height: 16px;
                }
                &:first-child {
                    // used to handle box-shadow not showing outside parent wrapper as it has overflow not visible
                    margin-top: 5px;
                }
            `,
        },
    },
    invoiceNumber: {
        css: css`
            white-space: nowrap;
        `,
    },
};

export const invoicePaymentTotalElementStyle = {
    wrapper: {
        css: css`
            flex: 0 0 ${specificCellWidth}px;
            width: ${specificCellWidth}px;
        `,
    },
    header: {
        wrapper: {
            css: css`
                border-bottom: 2px solid ${getColor("common.border")};
                background: ${getColor("common.ui3")};
                width: auto;
                text-align: left;
                text-transform: uppercase;
                border: 0;
                height: 38px;

                box-sizing: border-box;
                padding: 0 12px;
                white-space: nowrap;
                display: flex;
                align-items: center;
            `,
        },
        title: {
            size: 13,
            css: css`
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 1px;
                line-height: 16px;
            `,
        },
    },
    content: {
        wrapper: {
            css: css`
                box-sizing: border-box;
                height: 65px;
                padding: 0 12px;
                white-space: nowrap;
                text-align: right;
                padding: 22px 12px 22px 0;

                width: ${specificCellWidth}px;

                display: flex;
                align-items: center;
                justify-content: flex-end;
                background: ${getColor("common.background")};
            `,
        },
        text: {
            size: 15,
            css: css`
                color: ${(props: any) => props.isError && color("danger")};
                font-weight: ${(props: any) => props.isError && 600};
                white-space: break-spaces;
            `,
        },
    },
};
